import { useState } from 'react'
import UpIcon from 'assets/images/rectangle/up1.svg'
import DownIcon from 'assets/images/rectangle/down1.svg'
import moment from 'jalali-moment'
import Detail from './detail'
import { UseMutateFunction } from 'react-query'
import { AxiosResponse } from 'axios'
import { demandPeriority } from '../utilities'
import classNames from 'classnames'
import DeleteModal from './detail/modal'
interface IPayload {
    id: string | undefined
    loanId: number
}
interface IItemProps {
    item: IDemandResult
    isLoading: boolean
    mutate: UseMutateFunction<
        AxiosResponse<any, any>,
        unknown,
        IPayload,
        unknown
    >
}
interface IModal {
    show: boolean
    loanId: number
}
export default function Item({ item, isLoading, mutate }: IItemProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [isOpenModal, setIsOpenModal] = useState<IModal>({
        show: false,
        loanId: 0,
    })
    return (
        <div
            className=" px-2 py-2 rounded-lg mx-3 bg-white shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)] my-3"
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className=" flex justify-between items-center">
                <p>{item.poolship && item.poolship.name}</p>
                <div className=" items-center flex">
                    <p
                        className={classNames(
                            'text-sm rounded-full mx-2 px-3 py-0.5',
                            item.demand_priority === 'URGENT'
                                ? ' text-error-3 bg-error-4'
                                : ' text-gray-6 bg-gray-5'
                        )}
                    >
                        {demandPeriority[item.demand_priority]}
                    </p>
                    <img src={isOpen ? UpIcon : DownIcon} alt="rect-angle" />
                </div>
            </div>
            <div className=" flex justify-between my-2">
                <p className=" text-sm">
                    {item.amount && item.amount.toLocaleString()} تومان
                </p>
                <p>|</p>
                <p className=" text-sm">{item.num_repayments} قسط</p>
                <p>|</p>
                <p className=" text-sm">
                    {moment
                        .from(item.created, 'YYYY-MM-DD')
                        .locale('fa')
                        .format('YYYY')}
                    /
                    {moment
                        .from(item.created, 'YYYY-MM-DD')
                        .locale('fa')
                        .format('MM')}
                    /
                    {moment
                        .from(item.created, 'YYYY-MM-DD')
                        .locale('fa')
                        .format('DD')}
                </p>
            </div>
            <div>
                {isOpen && (
                    <Detail
                        item={item}
                        isLoading={isLoading}
                        mutate={mutate}
                        setIsOpen={setIsOpen}
                        setModal={setIsOpenModal}
                    />
                )}
            </div>
            <DeleteModal
                type="submit"
                onHide={() => setIsOpenModal({ ...isOpenModal, show: false })}
                show={isOpenModal.show}
                mutate={mutate}
                loanId={isOpenModal.loanId}
            />
        </div>
    )
}
